import { useHomeBanner, useHomeData, useHomeToolsData, useHomeLatestUpdatesPostData } from '@/src/api/getData';
import useScrollToHash from '@/components/_common/hook_scroll_to_hash';
import { AnimateOnScroll, AnimateOnScrollChild } from '@/components/_transitions/animate_on_scroll';
import { BannerImage } from '@/components/bannerImage';
import sortByDate from '@/components/SortByDate';
import LatestUpdatesCards from '@/components/latestUpdatesCards';

const HomeView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: homeData } = useHomeData(language);
    const { data: homeToolsData } = useHomeToolsData(language);
    const { data: latestUpdates } = useHomeLatestUpdatesPostData(language);

    const homeDataContent = homeData?.data || {};
    const homeToolsContent = homeToolsData?.data?.Tools || [];
    const coreProductsHeader = homeToolsData?.data?.CoreProducts?.Header || {};
    const coreProductsCards = homeToolsData?.data?.CoreProducts?.Card || [];

    const AboutOctopusHeader = homeDataContent?.AboutOctopus?.Header || {};
    const editorSpecifications = homeDataContent?.AboutOctopus?.tableEditor || {};
    const CoreServicesHeader = homeDataContent?.CoreServices?.Header || {};
    const coreServicesCards = homeDataContent?.CoreServices?.Card || [];

    useScrollToHash(homeDataContent, homeToolsContent, coreProductsCards);

    const isLoadedAboutOctopusContent = Object.keys(homeDataContent?.AboutOctopus || {}).length > 0;
    const isLoadedHomeToolsContent = homeToolsContent.length > 0;
    const isLoadedCoreProductsCards = coreProductsCards.length > 0;
    const isLoadedCoreServicesCards = coreServicesCards.length > 0;
    let latestUpdatesData = latestUpdates?.data || [];
    latestUpdatesData = sortByDate(latestUpdatesData);
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';
    return (
        <>
            <div className="navbar-color deep-blue"></div>
            <main className='main theme-home'>

                <section className="home-banner-section">
                    <AnimateOnScroll transition=' ' className=' '>
                        {banner?.data?.banner && banner.data.banner.map((item: any, index: number) => (
                            item.Category === "Home" && (
                                <div className="container" key={index}>
                                    <div className='bannerImage'>
                                        <AnimateOnScrollChild transition={`fade`} delay={600}>
                                            <BannerImage src={item?.image?.url} alt={item.title} />
                                        </AnimateOnScrollChild>
                                    </div>
                                    <div className='bannerContent'>
                                        <AnimateOnScrollChild as={`h1`} transition={`fade`}>
                                            {item.title}
                                            <br />
                                            <AnimateOnScrollChild as={`span`} transition={`fade`} delay={300}>
                                                {item.description}
                                            </AnimateOnScrollChild>
                                        </AnimateOnScrollChild>
                                    </div>
                                </div>
                            )))}
                    </AnimateOnScroll>
                </section>

                {
                    isLoadedAboutOctopusContent && (
                        <section className="home-about" id="start">
                            <AnimateOnScroll className="container">
                                <div id="aboutUs" style={{ transform: `translateY(-30px)` }} ></div>
                                <AnimateOnScrollChild delay={300}>
                                    <h2>{AboutOctopusHeader.ColorOne}{language == "en" ? " " : ""}<span>{AboutOctopusHeader.ColorTwo}</span></h2>
                                </AnimateOnScrollChild>
                                <AnimateOnScrollChild delay={600}>
                                    <div className='about-content' dangerouslySetInnerHTML={{ __html: editorSpecifications }}></div>
                                </AnimateOnScrollChild>
                            </AnimateOnScroll>
                        </section>
                    )
                }

                <section className="latest-updates-home container">
                    <h2 className='h2-main'>{language == "en" ? "Latest " : "最新"}<span>{language == "en" ? "Updates" : "動態"}</span></h2>
                    <div className="latest-update-content">
                        <LatestUpdatesCards latestUpdatesData={latestUpdatesData} language={language} name={"all"} />
                    </div>
                    <div className="more-updates">
                        <a href={"/" + language + "/latest-updates"}>{language == "en" ? "More Updates..." : "更多動態..."}</a>
                    </div>
                </section>

                {
                    isLoadedCoreServicesCards && (
                        <section className="core-services">
                            <AnimateOnScroll className="container">
                                <div id="coreServices" style={{ transform: `translateY(-30px)` }} ></div>
                                <AnimateOnScrollChild>
                                    <h2 className="h2-main">{CoreServicesHeader.ColorOne}{language == "en" ? " " : ""}<span>{CoreServicesHeader.ColorTwo}</span></h2>
                                </AnimateOnScrollChild>
                                <div className="services-cards">
                                    <AnimateOnScrollChild className="card main-card" delay={100}>
                                        <img src={`${locateSrc}${coreServicesCards[0]?.Icon.url}`} alt={coreServicesCards[0]?.Title.replace(/<br\s*\/?>/gi, ' ')} />
                                        <h3 className='about-content' dangerouslySetInnerHTML={{ __html: coreServicesCards[0]?.Title }} />
                                    </AnimateOnScrollChild>
                                    <div className="cards-group">
                                        {coreServicesCards.slice(1).map((card: any, index: number) => (
                                            <AnimateOnScrollChild className="card sub-card" key={index} delay={(index + 2) * 100}>
                                                <img src={`${locateSrc}${card.Icon.url}`} alt={card.Title.replace(/<br\s*\/?>/gi, ' ')} />
                                                <div className='about-content' dangerouslySetInnerHTML={{ __html: card.Title }} />
                                            </AnimateOnScrollChild>
                                        ))}
                                    </div>
                                </div>
                            </AnimateOnScroll>
                        </section>
                    )
                }

                {
                    isLoadedHomeToolsContent && (
                        <section className='otherLearningTools container'>
                            <AnimateOnScroll className='item-container home-tools'>
                                {homeToolsContent.map((tool: any, index: number) => (
                                    <AnimateOnScrollChild className='item' key={index} delay={(index + 1) * 100}>
                                        <div>
                                            <div className='icon'>
                                                <img src={`${locateSrc}${tool.Icon?.url || "/images/icons/octodap-01-ai-driven.svg"}`} alt={tool.Title?.replace(/<br\s*\/?>/gi, ' ') || "Tool"} />
                                            </div>
                                            <div className='title'>{tool.Title}</div>
                                        </div>
                                    </AnimateOnScrollChild>
                                ))}
                            </AnimateOnScroll>
                        </section>
                    )
                }

                {
                    isLoadedCoreProductsCards && (
                        <section className='functionIntroduction container'>
                            <AnimateOnScroll>
                                <div id="coreProducts" style={{ transform: `translateY(-30px)` }} ></div>
                                <AnimateOnScrollChild>
                                    <h2 className='h2-main'>{coreProductsHeader.ColorOne}{language == "en" ? " " : ""}<span>{coreProductsHeader.ColorTwo}</span></h2>
                                </AnimateOnScrollChild>
                                <div className='item-container'>
                                    {coreProductsCards.map((item: any, index: number) => {
                                        return (
                                            <AnimateOnScrollChild className='item coreProducts' key={index} delay={(index + 1) * 100}>
                                                <div>
                                                    {item.Url ? <>
                                                     <a href={"/" + language + item.Url}>
                                                        <div className='icon'>
                                                            {<img src={`${locateSrc}${item.Icon?.url || "/images/icons/default-icon.svg"}`} alt={item.Title?.replace(/<br\s*\/?>/gi, ' ') || "Product"} />}
                                                        </div>
                                                        <div className='title'>
                                                            {item.Title}
                                                        </div>
                                                        </a>
                                                    </> : <>
                                                        <div className='icon'>
                                                            {<img src={`${locateSrc}${item.Icon?.url || "/images/icons/default-icon.svg"}`} alt={item.Title?.replace(/<br\s*\/?>/gi, ' ') || "Product"} />}
                                                        </div>
                                                        <div className='title'>
                                                            {item.Title}
                                                        </div>
                                                    </>}

                                                </div>

                                            </AnimateOnScrollChild>
                                        );
                                    })}
                                </div>
                            </AnimateOnScroll>
                        </section>
                    )
                }
            </main>
        </>
    );
}

export default HomeView;